import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative'
  },
  line: {
    width: 3,
    backgroundColor: theme.palette.grey[300],
    position: 'relative',
    height: 280
  },
  shortLine: {
    height: 140
  },
  accessButton: {
    boxSizing: 'content-box',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '50%',
    width: 110,
    aspectRatio: '1 / 1',
    padding: 15,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    border: `20px solid ${theme.palette.background.default}`,
    borderRight: 'none',
    // cursor: 'pointer',
    borderLeft: 'none',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark
    }
  },
  resetButton: {
    boxSizing: 'content-box',
    backgroundColor: theme.palette.grey[200],
    borderRadius: '50%',
    aspectRatio: '1 / 1',
    border: `15px solid ${theme.palette.background.default}`,
    width: 68,
    '&:hover': {
      backgroundColor: theme.palette.grey[300]
    }
  },
  buttonText: {
    lineHeight: 1,
    fontSize: 18,
    color: theme.palette.primary.contrastText,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      transform: 'rotate(-45deg)',
      fontSize: 70
    }
  },
  buttonTextSmall: {
    fontSize: 14,
    color:
      theme.palette.type === 'dark'
        ? theme.palette.primary.light
        : theme.palette.primary.dark,
    '& svg': {
      fontSize: 35
    }
  }
}))

export default useStyles
